<template>
  <div id="section-editor-add">
    <ipub-model :title="params.id?'Edit Information':'Edit Information'"
                width="1100px"
                :visable="isVisable"
                @confirm="confirm"
                @cancel="cancel">
      <ipub-form ref="section-editor-form"
                 :model="params"
                 :rules="rules">
        <ipub-row>
          <ipub-col :span="9.5">
            <ipub-row :gutter="20">
              <ipub-col :span="4">
                <ipub-form-item prop="firstName"
                                label="First Name">
                  <ipub-input placeholder="First Name"
                              v-model.trim="params.firstName" />
                </ipub-form-item>
              </ipub-col>
              <ipub-col :span="4">
                <ipub-form-item prop="lastName"
                                label="Last Name">
                  <ipub-input placeholder="Last Name"
                              v-model.trim="params.lastName" />
                </ipub-form-item>
              </ipub-col>
              <ipub-col :span="4">
                <ipub-form-item prop="sort"
                                label="Hierarchy">
                  <ipub-input placeholder="Hierarchy"
                              v-model.trim="params.sort" />
                </ipub-form-item>
              </ipub-col>

            </ipub-row>
            <ipub-row :gutter="20">
              <ipub-col :span="6">
                <ipub-form-item prop="degreesIdList"
                                label="Degree / Credential">
                  <ipub-select placeholder="Degree / Credential"
                               mode="multiple"
                               :tree="true"
                               search
                               @search="getDegrees"
                               v-model="params.degreesIdList">
                    <ipub-select-option v-for="item in degreesList"
                                        :key="item.id"
                                        :value="item.id"> {{item.name}}<template v-if="item.otherName">({{item.otherName}})</template>
                    </ipub-select-option>
                  </ipub-select>
                </ipub-form-item>
              </ipub-col>
              <ipub-col :span="6">
                <ipub-form-item prop="rankId"
                                label="Academic Rank / Scientific Rank">
                  <ipub-select v-model="params.rankId"
                               search
                               @search="getAcademic"
                               placeholder="Academic Rank / Scientific Rank"
                               :options="academicList" />
                </ipub-form-item>
              </ipub-col>
            </ipub-row>
          </ipub-col>
          <ipub-col :span="2.5">
            <ipub-form-item prop="icon">
              <div class="upload-content right-option">
                <div class="upload-content-img">
                  <ipub-upload-cropper @change="(e)=>{handleUpload('icon', e)}"
                                       :canWidth="105"
                                       :canHeight="130"
                                       :scales="2"
                                       :imgUrl="params.icon?domain+'/'+params.icon:domain+'/imageFile/icon.svg'" />
                </div>
              </div>
            </ipub-form-item>
          </ipub-col>
        </ipub-row>
        <ipub-row :gutter="20">
          <ipub-col :span="6">
            <ipub-form-item prop="email"
                            label="Email">
              <ipub-input placeholder="Email"
                          @blur="getEditor"
                          v-model.trim="params.email" />
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="6">
            <ipub-form-item prop="identityCode"
                            label="Identity">
              <ipub-select v-model="params.identityCode"
                           placeholder="Title">
                <ipub-select-option v-for="(value) in sectionEditorList"
                                    v-show="value.enabled"
                                    :key="value.id"
                                    :value="value.code">
                  {{value.name}}
                </ipub-select-option>
              </ipub-select>
            </ipub-form-item>
          </ipub-col>
        </ipub-row>
        <ipub-form-item prop="affiliation"
                        label="Affiliations">
          <div v-for="(item, index) in params.affiliations"
               class="mar-b-10"
               :key="'params.affiliations'+index">
            <ipub-input placeholder="Affiliations"
                        suffixIcon="iconClose"
                        @blur="getMore('affiliation')"
                        @iconClick="delMore('affiliations',index)"
                        v-model.trim="params.affiliations[index]" />
          </div>
          <ipub-button type="primary"
                       icon="iconAdd"
                       @click="addMore('affiliations')"
                       style="width:240px"
                       plain>Add Affilications</ipub-button>
        </ipub-form-item>
        <!-- <ipub-form-item prop="journalId"
                        label="Reviewer Board Member">
          <ipub-select placeholder="Journal"
                       :options="personalJournalList"
                       mode="multiple"
                       optionKey="id"
                       v-model="journalId" />
        </ipub-form-item> -->
        <!-- <ipub-form-item prop="journalId"
                        label="Journal">
          <ipub-select placeholder="Journal"
                       :options="personalJournalList"
                       disabled
                       optionKey="id"
                       v-model="journalId" />
        </ipub-form-item> -->

        <ipub-row :gutter="20">
          <ipub-col :span="2">
            <ipub-form-item prop="hindex"
                            label="H-index">
              <ipub-input placeholder="Last Name"
                          :disabled="!params.hindexed"
                          number
                          v-model.trim="params.hindex" />
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="10">
            <ipub-form-item prop="hindexUrl"
                            label="H-index URL">
              <ipub-input placeholder="H-index URL"
                          v-model.trim="params.hindexUrl" />
            </ipub-form-item>
          </ipub-col>
        </ipub-row>
        <ipub-form-item prop="hindex">
          <ipub-radio :checked="params.hindexed"
                      @change="()=>{params.hindexed = !params.hindexed}"
                      label="Choose to show H-index" />
        </ipub-form-item>
        <ipub-form-item prop="interest"
                        label="Interest">
          <!-- <ipub-editor :height="200"
                       v-model="params.interest" /> -->
          <ipub-textarea :autoSize="{ cols: '', rows: '5' }"
                         v-model="params.interest" />
        </ipub-form-item>
        <ipub-row :gutter="20">
          <ipub-col :span="4">
            <ipub-form-item prop="orcid"
                            label="ORCID">
              <ipub-input placeholder="ORCID"
                          v-model.trim="params.orcid" />
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="4">
            <ipub-form-item prop="researchGate"
                            label="ReasearchGate Account">
              <ipub-input placeholder="ReasearchGate Account"
                          v-model.trim="params.researchGate" />
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="4">
            <ipub-form-item prop="website"
                            label="Website">
              <ipub-input placeholder="Website"
                          v-model.trim="params.website" />
            </ipub-form-item>
          </ipub-col>
        </ipub-row>
        <ipub-form-item prop="reviewJournal"
                        label="Reviewed Journal">
          <div v-for="(item, index) in params.reviewJournals"
               class="mar-b-10"
               :key="'params.reviewJournals'+index">
            <ipub-input placeholder="Reviewed Journal"
                        suffixIcon="iconClose"
                        @blur="getMore('reviewJournal')"
                        @iconClick="delMore('reviewJournals',index)"
                        v-model.trim="params.reviewJournals[index]" />
          </div>
          <ipub-button type="primary"
                       icon="iconAdd"
                       @click="addMore('reviewJournals')"
                       style="width:240px"
                       plain>Add Reviewed Journal</ipub-button>
        </ipub-form-item>
        <ipub-form-item label="Attachment(s)">
          <ipub-upload-input :file="params"
                             _name="cvName"
                             _path="cv"
                             class="mar-b-20"
                             :loading="loading"
                             :domain="domain"
                             @delete="delFile('cv')"
                             @change="(e)=>{handleUpload('cv', e)}" />
        </ipub-form-item>
      </ipub-form>
    </ipub-model>
    <!-- <AddRank :isVisable="showRank"
             @confirm="dialogConfirm"
             @cancel="dialogCancel" />
    <AddDegree :isVisable="showDegree"
               @confirm="dialogConfirm"
               @cancel="dialogCancel" /> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import AddDegree from '../../editorial-board/addDegree.dialog.vue'
// import AddRank from '../../editorial-board/addRank.dialog.vue'
import { settingOption } from '@/api/setting'
import { getUploadConfig } from '@/utils/upload'
import help from '@/utils/help'

export default {
  components: {
    // AddDegree, AddRank
  },
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    hasSection: {
      type: String,
      default: '',
    },
    tree: {
      type: Array,
      default () {
        return []
      },
    },
  },

  data () {
    return {
      params: {
        hindexed: false,
        affiliations: [],
        reviewJournals: []
      },
      rules: {},
      showRank: false,
      showDegree: false,
      degreesList: [],
      academicList: [],
      sectionEditorList: []
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      journalId: 'getJournalId',
      personalJournalList: 'getPersonalJournalList',
      domain: 'getDomain',
      sectionEditor: 'getSectionEditor',
      title: 'getTitle',
      degree: 'getDegree',
    })
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.params = {
          hindexed: false,
          affiliations: [''],
          reviewJournals: ['']
        }
      } else {
        if (this.hasSection) {
          this.params.parentId = this.hasSection
          this.rules.parentId = [
            {
              required: true,
              message:
                'Section Belonged To' +
                this.LANGUAGE[this.language].noEmpty
            }
          ]
        }
      }
    },
  },
  mounted () {
    this.getRules()
    // this.getDegrees()
    // this.getAcademic()
    this.getData()
  },
  methods: {
    async getQuery (val) {
      this.params = val
      this.params.affiliations = val.affiliation ? val.affiliation.split(';') : ['']
      this.params.reviewJournals = val.reviewJournal ? val.reviewJournal.split(';') : ['']
      this.params.degreesIdList = val.degreesList
        ? val.degreesList.map(item => {
          return item.id
        })
        : []
    },
    async getData () {
      const academicList = await settingOption.get({ type: 'ACADEMIC_RANK' })
      const degreesList = await settingOption.get({ type: 'DEGREE' })
      const sectionEditorList = await settingOption.get({ type: 'SECTION_EDITOR_IDENTITY' })
      this.academicList = academicList
      this.degreesList = degreesList
      this.sectionEditorList = sectionEditorList
    },
    delFile (key) {
      this.params[key] = ''
      this.params[key + 'Name'] = ''
    },
    async confirm () {
      const flag = this.$refs['section-editor-form'].validate()
      // if (
      //   !this.params.degreesIdList ||
      //   (this.params.degreesIdList && this.params.degreesIdList.length === 0)
      // ) {
      //   this.$message.error({
      //     title: 'Error',
      //     content: 'Degree / Credential cannot be empty!'
      //   })
      //   return
      // }
      if (flag) {
        this.$emit('confirm', this.params)
      }
    },

    async getAcademic (keyword) {
      // this.academicList = await academic.getAll({ keyword })
      this.academicList = await settingOption.get({ keyword, type: 'ACADEMIC_RANK' })

    },
    async getDegrees (keyword) {
      // this.degreesList = await degrees.getAll({ keyword })
      this.degreesList = await settingOption.get({ keyword, type: 'DEGREE' })
    },
    addRank () {
      this.showRank = true
    },
    addDegree () {
      this.showDegree = true
    },
    cancel () {
      this.$emit('cancel')
    },
    getRules () {
      this.rules = {
        firstName: [
          {
            required: true,
            message:
              'FirstName' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        lastName: [
          {
            required: true,
            message:
              'LastName' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        email: [
          {
            required: true,
            message: 'Email' + this.LANGUAGE[this.language].noEmpty
          },
          {
            type: 'email',
            message: this.LANGUAGE[this.language].enterCorrent + 'Email'
          },
        ],
        identityCode: [
          {
            required: true,
            message:
              'Identity' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        interest: [
          {
            required: true,
            message:
              'Interest' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
      }
    },
    getEditor () {

    },
    async handleUpload (key, files) {
      const file = files[0]
      const imgFiles = ['icon']
      const pdfFiles = ['cv']
      const imgTypes = ['image/jpeg', 'image/png']
      const pdfTypes = ['application/pdf']
      let rightType = true
      if (imgFiles.includes(key)) {
        rightType = imgTypes.includes(file.type)
      } else if (pdfFiles.includes(key)) {
        rightType = pdfTypes.includes(file.type)
      }
      if (!rightType) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].isWrongType
        })
        return false
      }
      const MS = 2
      const maxSize = file.size / 1024 / 1024 < MS
      if (!maxSize) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].notExceed + MS + 'MB'
        })
        return false
      }
      const url = await getUploadConfig(file, `${this.publisherId}/journal/${this.journalId}/guest-editor/${key}/${help.guid()}`)

      if (url.includes('err:')) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].uploadFileFail
        })
        return false
      }

      this.$set(this.params, key + 'Name', file.name)
      this.$set(this.params, key, url)
    },
    addMore (key) {
      this.params[key].push('')
    },
    getMore (key) {
      const arr = []
      this.params[key + 's'].forEach(item => {
        if (item) {
          arr.push(item)
        }
      })
      this.params[key] = arr.join(';')
    },
    delMore (key, index) {
      if (this.params[key].length === 1) {
        return
      }
      this.params[key].splice(index, 1)
    },
    goToPage (val) {
      window.open(val)
    },
    // dialogConfirm () {
    //   this.showRank = false
    //   this.showDegree = false
    //   this.getDegrees()
    //   this.getAcademic()
    // },

    // dialogCancel () {
    //   this.showRank = false
    //   this.showDegree = false
    // },
  }
}
</script>

<style lang="scss" scoped>
#system-database-add {
  .upload-content {
    height: 151px;
    width: 151px;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    &-img {
      border-radius: 4px;
      height: 140px;
      width: 125px;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
</style>
